export default function not(filter) {
    return (item) => {
        return !filter(item);
    };
}
